import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Box, Flex, Button} from 'rebass';
import {Block, Input, Tabs} from 'reakit'
import {Content, DesktopBox, TabHeader} from "../Base";
import SearchInput from './PopupSearchInput'
import UserList from '../UserList'
import Loading from '../Base/Loading'
import styled from "styled-components";

import {searchActions, searchSelectors} from "../../store/search";
import {chatActions} from "../../store/chat";

import IosClose from 'react-ionicons/lib/IosClose'

import { 
    Header,
    Right,
    Left,
    IconWrapper,
    LeftText
} from './Styles';

const ListWrapper = styled(Box)`

`

ListWrapper.defaultProps = {
	// height: ['calc(100vh - 162px)', 'calc(100vh - 330px)']
};

const Wrapper = styled(Box)`
    height: 400px;
    // overflow-y: scroll;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #ffffff;
    background-color: #ffffff;
`
const CreateButton = styled(Button)`
    width: 70.1px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
`;

const ScrollWrapper = styled(Box)`
    height: 300px;
    overflow-y: scroll;
`

class NewChatPopup extends Component {

	state = {
		name: '',
        selected: [],
        students: [],
        faculty: [],
        loading: false,
        isStudentTab: true
	};


	componentDidMount() {

		this.setState({loading: true});
		this.studentListener = this.props.firebase.students().orderBy('last_name', 'asc').onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				this.setState({students: result, loading: false})
			}
		);
		this.facultyListener = this.props.firebase.faculties().orderBy('last_name', 'asc').onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				this.setState({faculty: result, loading: false})
			}
		)
	}


	componentWillUnmount() {
		//this.studentListener();
		//this.facultyListener();
    }
    
	handleSubmit = async () => {
		const {selected, name} = this.state;
		const {profile, isFaculty, firebase} = this.props;
		let status = 0;
		if (isFaculty) {
			status = 1
		}
		let isGroup = false;
		let accepted = {status: status, updated_at: Math.floor(Date.now() / 1000)};
		if (selected.length > 1) {
			isGroup = true;
			accepted = {status: status, updated_at: Math.floor(Date.now() / 1000), members: [], declined: {}}
		}
		const members = [profile.id, ...selected];
		let result = false;
		if (isGroup === false) {
			result = await this.checkIfExists(members)
		}

		if (result !== true) {
			let newChatRef = firebase.chats().doc();
			newChatRef.set({
				creator_uid: profile.id,
				is_group: isGroup,
				members: members,
				post_time: Math.floor(Date.now() / 1000),
				last_updated: Math.floor(Date.now() / 1000),
				messages: [],
				accepted,
				name
            })
            //console.log('newChatRef : ', newChatRef);
            this.props.switchMessageWindow(newChatRef.id);
		}

	};

	checkIfExists = async (members) => {
		const {firebase } = this.props;
		try {
			let chatQuery = await firebase.chats().where('members', '==', members).where('is_group', '==', false).get();
			// console.log('chatquery', chatQuery);
			if (chatQuery.docs.length > 0) {
                this.props.switchMessageWindow(chatQuery.docs[0].id);
				return true
			} else {
				chatQuery = await firebase.chats().where('members', '==', members.reverse()).where('is_group', '==', false).get();
				if (chatQuery.docs.length > 0) {
                    this.props.switchMessageWindow(chatQuery.docs[0].id);
					return true
				}
			}
		} catch (err) {
			//console.log(err)
		}
		return false
	};

	handleSelect = (details) => {
		let {selected} = this.state;
		//console.log('new chat', details);
		let contains = false;
		for (var i = selected.length - 1; i >= 0; i--) {
			if (selected[i] === details.id) {
				selected.splice(i, 1);
				contains = true;
				this.setState({selected})
				// break;       //<-- Uncomment  if only the first term has to be removed
			}
		}

		if (!contains) {
			selected.push(details.id);
			this.setState({selected})
		}

	};

	filterListWithSearch = (list, search = '') => {
		// console.log( search)
		return list.filter(student => {
			// console.log(student)
			if (student.first_name) {
				return (student.first_name.toLowerCase() + ' ' + student.last_name.toLowerCase()).includes(search.toLowerCase())

			} else {
				return false
			}
		})
	};

	handleInput = (e) => {
		this.setState({name: e.target.value})
	};

    onBackClick = (e) => {
		e.stopPropagation();
		this.props.back();
    }
    
    preventToggle = (e) => {
        e.stopPropagation();
    }

	render() {
        const {profile, search, isMinimized} = this.props;

		const {loading, students, faculty, selected, name} = this.state;
		const count = selected.length;
		let id = 0;
		if (profile && profile.id) {
			id = profile.id
		}
		let studentList = students;
		let facultyList = faculty;
		if (search !== null && search !== undefined) {
			if (facultyList.length > 0) {
				facultyList = this.filterListWithSearch(faculty, search)

			}
			if (studentList.length > 0) {
				studentList = this.filterListWithSearch(students, search)

			}
		}

		let disableButton = true
		if(count > 0 ){
			disableButton = false
		}
		return (
            <>
                <Header onClick={this.props.toggleBox}>
                        <Left
                            p={3}
                            width={3/4}
                        >
                            { count > 1 ? 
                                <Input 
                                    onClick={this.preventToggle}
                                    placeholder={'Group name...'} 
                                    value={name}
                                    onChange={this.handleInput} 
                                    color='#263039' 
                                    maxHeight='30px' 
                                    paddingLeft={5} 
                                    margin={0}
                                />
                                :
                                <LeftText>
                                    New Chat
                                </LeftText> 
                            }
                        </Left>
                        <Right
                            p={3}
                            width={1/4}
                        >
                            <IconWrapper onClick={(e) => this.onBackClick(e)}>
                                <IosClose fontSize={'80px'} color={'white'}/>
                            </IconWrapper>
                        </Right>
                </Header>
                {
                    !isMinimized &&
                    <Wrapper>
                        <DesktopBox  pl={1} pb={1} pt={1} pr={1}>
                            <Flex justifyContent={'center'} alignItems={'center'}>
                                {   
                                    profile !== null &&
                                    <Box width={[ 3/4]} pr={3}>
                                        <SearchInput placeholder={this.state.isStudentTab ? 'Search Student' : 'Search Faculty'}/>
                                    </Box>
                                }
                                <CreateButton 
                                    disabled={disableButton}
                                    onClick={this.handleSubmit} 
                                    bg={disableButton ? 'gray': '#2b80b9'}
                                >
                                    {'Create'}
                                </CreateButton>
                            </Flex>
                        </DesktopBox>
                        <Tabs.Container>
                            {tabs => (
                                <Block>
                                    <Content>
                                        <DesktopBox>
                                        {/* 	<PageTitle color={'#263039'}  pl={3}>{count > 1 ? <Input placeholder={'Group name...'} width={'40%'} value={name}
                                                                                onChange={this.handleInput} color='#263039' maxHeight='30px' padding={0} margin={0}/>
                                                                                : 'New Chat'}</PageTitle> */}

                                        {/* 	<Text pl={4} pb={3} color={'meta'} fontWeight={600}>{count} selected</Text> */}

                                            <Tabs>
                                                <Tabs.Tab tab="first" {...tabs}><TabHeader
                                                    onClick={() => {
                                                        this.props.clearSearch();
                                                        this.setState({ isStudentTab: true });
                                                    }} title={'Students'}/></Tabs.Tab>
                                                <Tabs.Tab tab="second" {...tabs}><TabHeader
                                                    onClick={() => {
                                                        this.props.clearSearch();
                                                        this.setState({ isStudentTab: false });
                                                    }} title={'Faculty'}/></Tabs.Tab>
                                            </Tabs>
                                        </DesktopBox>
                                        <ScrollWrapper>
                                            <Tabs.Panel tab="first" {...tabs}>
                                                {
                                                    loading ? <Loading/> :
                                                    <ListWrapper>
                                                        <UserList 
                                                            students={studentList.filter(student => student.id !== id)}
                                                            handleUserClick={this.handleSelect}
                                                            selected={selected} 
                                                            infiniteScroll
                                                            useWindow
                                                            chatPopupWindow
                                                        />
                                                    </ListWrapper>

                                                }
                                            </Tabs.Panel>
                                            <Tabs.Panel tab="second" {...tabs}>
                                            {
                                                loading ? <Loading/> :
                                                <ListWrapper>
                                                    <UserList
                                                        students={facultyList.filter(faculty => faculty.id !== id)}
                                                        handleUserClick={this.handleSelect} 
                                                        selected={selected} 
                                                        facultyList 
                                                        useWindow
                                                        infiniteScroll
                                                        chatPopupWindow
                                                    />
                                                </ListWrapper>
                                            }
                                            </Tabs.Panel>
                                        </ScrollWrapper>
                                    </Content>

                                </Block>
                            )}
                        </Tabs.Container>
			        </Wrapper>    
                }
            </>
			
		)
	}

}



const mapStateToProps = state => ({
	search: searchSelectors.refreshPopupSearch(state.search)
});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	clearSearch: () => {
		dispatch(searchActions.clearPopupSearch());
	},
	updateChatId: (id) => {
		dispatch(chatActions.updateCurrentChat(id))
	}
});


export default connect(mapStateToProps, mapDispatchToProps)(NewChatPopup);



